import * as React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import { CssBaseline, StyledEngineProvider } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'

import theme from '@/theme'

const handleRefreshClick = async () => {
  const registrations = await navigator.serviceWorker.getRegistrations()
  registrations.forEach((r) => r.unregister())

  const keys = await caches.keys()
  await Promise.all(keys.map((key) => caches.delete(key)))

  setTimeout(() => {
    window.location.reload()
  }, 1000)
}

const ErrorFallback = () => (
  <div className="">
    <h1 className="">Please bear with us..</h1>
    <p>
      Sorry for the inconvenience. We suggest you <b>refresh the page</b> to
      resolve the issue.
    </p>
    <button className="" onClick={handleRefreshClick}>
      Refresh
    </button>
  </div>
)

type AppProviderProps = {
  children: React.ReactNode
}

export const AppProvider = ({ children }: AppProviderProps) => {
  React.useEffect(() => {
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual'
    }
  }, [])

  return (
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <HelmetProvider>
                  <BrowserRouter>
                    <CssBaseline />
                    {children}
                  </BrowserRouter>
                </HelmetProvider>
              </ErrorBoundary>
        </ThemeProvider>
    </StyledEngineProvider>
  )
}
